import { render, staticRenderFns } from "./RepairStatsTable.vue?vue&type=template&id=6407dac8&"
import script from "./RepairStatsTable.vue?vue&type=script&lang=js&"
export * from "./RepairStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports